// import 'react-hot-loader';
// import "@babel/polyfill";
require('./style.scss');

let $siteMenu;
function checkScrollPosition() {
	if (!$siteMenu || !$siteMenu.length) {
		$siteMenu = jQuery('.evtx-menu-basic');
		if (!$siteMenu.length) return;
	}
	const scrollPos = jQuery(window).scrollTop();
	if (scrollPos >= 200) {
		if ($siteMenu.hasClass('transparent')) {
			$siteMenu.removeClass('transparent');
		}
	}
	else {
		if (!$siteMenu.hasClass('transparent')) {
			$siteMenu.addClass('transparent');
		}
	}
}

jQuery(window).on('scroll', checkScrollPosition);
jQuery(window).on('load', checkScrollPosition);
jQuery(checkScrollPosition);